// extracted by mini-css-extract-plugin
export var dataCell = "_ku-2";
export var dataRow = "_ku-0";
export var headerRow = "_ku-1";